// Keep only identifiers, scoped to the authenticated customer and current/proxy cart.
export function getCheckoutPaymentKey ( {userGuid, cart, currentOrderGuid} ) {
    const orderGuid = cart?.orderGuid || currentOrderGuid;
    return userGuid && orderGuid
        ? `checkout.payment:${encodeURIComponent( userGuid )}:${encodeURIComponent( orderGuid )}`
        : null;
}

export function readCheckoutPayment ( key ) {
    if ( !key ) return null;
    try {
        const selection = JSON.parse( window.sessionStorage.getItem( key ) );
        return selection && Number.isInteger( selection.paymentId ) && selection.paymentId > 0 &&
            ['creditCard', 'terms'].includes( selection.paymentMethodType ) ? selection : null;
    }
    catch ( error ) {
        return null;
    }
}

export function saveCheckoutPayment ( key, payment, address ) {
    if ( !key ) return;
    try {
        if ( !payment ) {
            window.sessionStorage.removeItem( key );
            return;
        }
        window.sessionStorage.setItem( key, JSON.stringify( {
            paymentId: payment.id,
            paymentMethodType: payment.paymentMethodType,
            billingAddressId: address?.id || null
        } ) );
    }
    catch ( error ) {
        // Storage may be blocked or full; selection still works for the current page.
    }
}
